module.exports = __webpack_public_path__ + "assets/img/jianhua.981e5492.svg";